import { cartTotalDisplayStyles } from "@insite/content-library/Components/CartTotalDisplay";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    gap: 10,
    css: css`
        div[class^="GridOffset"] {
            width: 100% !important;
            div[class^="GridItemStyle"] {
                border-bottom: 2px solid #bdbbbd;
                padding: 17px 0px;
            }
            div[class^="cartTotal"] {
                padding: 17px 0px;
            }
        }
    `,
};

cartTotalDisplayStyles.labelGridItem = {
    width: 6,
    css: css`
        font-size: ${TYPOGRAPHY.size.large};
        font-weight: ${TYPOGRAPHY.weight.mediumbold};
        line-height: ${TYPOGRAPHY.lineHeight.base};
        color: ${getProp("theme.typography.p.color")};
    `,
};

cartTotalDisplayStyles.valueGridItem = {
    width: 6,
    css: css`
        font-size: ${TYPOGRAPHY.size.large};
        font-weight: ${TYPOGRAPHY.weight.base};
        line-height: ${TYPOGRAPHY.lineHeight.base};
        color: ${getProp("theme.typography.p.color")};
        align-items: center;
    `,
};

cartTotalDisplayStyles.subtotalValue = {
    css: css`
        margin-left: auto;
        font-weight: ${TYPOGRAPHY.weight.base};
    `,
};
